import Vue from 'vue'
import Vuex, { ActionTree, MutationTree } from 'vuex'
import { RootState } from './rootState'
import { UsuarioManager } from './usuarioManager'
import components from './components'
import documentosReceber from './documentosReceber'
import portal from './portal'

Vue.use(Vuex)

const rootState: RootState = {
    isLoading: true,
    isAuthenticated: false,
    erros: [],
    usuario: {} as UsuarioManager
}

const rootActions: ActionTree<RootState, RootState> = {
    login({ commit }, credentials) {
        commit('setIsLoading', true)
        commit('clearErro')
        return Vue.http.post('/api/auth/login', credentials)
            .then(res => {
                commit('setAuth', res.data)
                commit('setIsLoading', false)
            })
            .catch(err => {
                commit('setAuth', {})
                commit('addErro', err.response?.data?.erro ?? err.message)
                commit('setIsLoading', false)
            })
    },
    logout({ commit }) {
        commit('setIsLoading', true)
        return Vue.http.post('/api/auth/logout')
            .then(() => {
                commit('setAuth', {})
                commit('setIsLoading', false)
            })
            .catch(err => {
                commit('setAuth', {})
                commit('setIsLoading', false)
            })
    },
    restoreContext({ commit }) {
        commit('setIsLoading', true)
        return Vue.http.get('/api/auth/context')
            .then(res => {
                commit('setAuth', res.data)
                commit('setIsLoading', false)
            })
            .catch(err => {
                commit('setAuth', {})
                if (err.status != 401) {
                    if (err.message) {
                        commit('addErro', err.message)
                    }
                    if (err.response && err.response.data && err.response.data.erro) {
                        commit('addErro', err.response?.data?.erro)
                    }
                }
                commit('setIsLoading', false)
            })
    },
    get(any, url) {
        return new Promise((resolve, reject) => {
            Vue.prototype.http.get(url)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },
    post(any, { url, data }) {
        return new Promise((resolve, reject) => {
            Vue.prototype.http.post(url, data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
}

const rootMutations: MutationTree<RootState> = {
    addErro(state, erro) {
        state.erros.push(erro);
    },
    clearErro(state) {
        state.erros = [];
    },
    setIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setAuth(state, auth) {
        state.isAuthenticated = (auth.usuario !== undefined && auth.usuario !== '')
        state.usuario.nome = auth.usuario
        state.usuario.roles = auth.roles
        state.usuario.pessoa = auth.pessoa

        if (state.isAuthenticated) {
            Vue.prototype.$hub.start()
                .catch(err => console.error(err))
        } else {
            Vue.prototype.$hub.stop()
        }
    },
}

export default new Vuex.Store({
    state: rootState,
    actions: rootActions,
    mutations: rootMutations,
    modules: {
        components,
        documentosReceber,
        portal
    }
})
